<div class="pad-L">
	<div style="min-height: calc(80vh - 256px)">
		<div class="flex-align-center gap-S f-d-r mb-m">
			<app-chips [square]="true" [size]="'xl'">
				<img src="assets/icons/grid.svg" class="filter-grey" height="25px">
			</app-chips>
			<div class="flex-column gap-XS ml-s">
				<div class="font-L fw-700">{{ 'page.settings.agent.inventory' | translate }}</div>
				<div class="font-M fw-300">{{ 'page.settings.agent.inventorySubtitle' | translate }}</div>
			</div>
		</div>

		<div class="flex flex-align-center gap-S mb-m">
			<app-text-input
				class="w-100"
				[placeholder]="'page.settings.agent.search' | translate"
				[input]="searchInput">
			</app-text-input>
		</div>

		<div class="bg-rounded-2 custom-scrollbar applications-list" style="max-height: calc(80vh - 300px); min-height: calc(80vh - 300px); overflow-x: hidden;">
			<div>
				<div *ngFor="let app of filteredApplications; let i = index">
					<div class="pad-L flex-justify-center flex-column">
						<div class="flex-space-between">
							<div class="disp-f a-i-c gap-S overflow-hidden">
								<app-display-logo [logo]="app.logo" [size]="30"></app-display-logo>
								<span class="font-M text-overflow-ellipsis">{{ app.name }}</span>
							</div>
							<mat-checkbox
								class="custom-checkbox"
								[checked]="isApplicationSelected(app)"
								(change)="onCheckChange(app, $event)">
							</mat-checkbox>
						</div>
					</div>
					<hr *ngIf="i < filteredApplications.length - 1" />
				</div>

				<div *ngIf="filteredApplications.length <= 0 && data.applications.length > 0"
					 class="flex-center flex-column gap-M empty-state">
					<img src="assets/illustrations/empty-capacity.svg">
					<span class="grey">{{ 'page.settings.agent.noAppSearch' | translate }}</span>
				</div>
				<div *ngIf="data.applications.length <= 0"
					 class="flex-center flex-column gap-M empty-state">
					<img src="assets/illustrations/empty-capacity.svg">
					<span class="grey">{{ 'page.settings.agent.noApp' | translate }}</span>
				</div>
			</div>
		</div>
	</div>

	<div class="w-100 disp-f f-d-r j-c-sb a-i-c mt-l gap-M">
		<app-text-button class="w-50" type="stroked" (click)="onCancel()">
			{{ 'button.cancel' | translate }}
		</app-text-button>
		<app-text-button
			class="w-50"
			type="flat"
			(click)="onSave()">
			{{ 'button.save' | translate }}
<!--			<span *ngIf="selectedApplications.length > 0"></span>-->
		</app-text-button>
	</div>

</div>
